import React, { useState, useEffect } from 'react';
import {
   Box,
   Button,
   Chip,
   Divider,
   Grid,
   Switch,
   Typography,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { TitleLabel } from '../../Element/LabelInputForm';
import { AlertLabel, Input } from '../../../assets/styled/Element';
import SearchEmployee from '../../Search/SearchEmployee';
import SearchDivision from '../../Search/SearchDivision';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import CheckBoxSelect from './../../Select/CheckBoxSelect';

const columnsA = [
   {
      field: 'orgEmployeeId',
      title: 'รหัสพนักงาน',
      width: 150,
      editable: 'never',
   },
   {
      field: 'nameTh',
      title: 'ชื่อ-นามสกุล',
   },
   {
      field: 'divisionName',
      title: 'สังกัด',
   },
];
function PermissionBoxConfig(props) {
   const [isLoading, setIsLoading] = useState(false);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [innerTableData, setInnerTableData] = useState([]);
   const [selected, setSelected] = useState(null);
   const [selectShowDashboard, setSelectShowDashboard] = useState(false);
   const [
      isLoadingDashboardCheckboxStatus,
      setIsLoadingDashboardCheckboxStatus,
   ] = useState(false);
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm();

   useEffect(() => {
      setInnerTableData(props.permission.permissionEmployeeList);
   }, [props.permission]);

   const handleSelect = (e) => {
      if (e) {
         setSelected(e);
      } else {
         setSelected(null);
      }
   };

   const onAddEmployee = () => {
      if (selected) {
         const isExist = innerTableData.find(
            (el) => selected.data.employeeId === el.orgEmployeeId,
         );
         if (isExist) {
            enqueueSnackbar(
               'ไม่สามารถเพิ่มรายชื่อซ้ำได้ โปรดเลือกรายชื่ออื่น',
               {
                  variant: 'error',
               },
            );
         } else {
            let formatted = {
               orgEmployeeId: selected.data.employeeId,
               nameTh: selected.data.displayName,
               nameEn: selected.data.description,
               divisionName: selected.data.streetAddress,
               isActive: true,
            };
            setInnerTableData([formatted, ...innerTableData]);
            setSelected(null);
         }
      } else {
         enqueueSnackbar('กรุณาระบุรายชื่อพนักงาน', {
            variant: 'error',
         });
      }
   };

   const onToggleActive = (rowData) => () => {
      let index = innerTableData.findIndex(
         (el) => rowData.orgEmployeeId === el.orgEmployeeId,
      );
      let obj = innerTableData[index];
      obj.isActive = !obj.isActive;
      setInnerTableData([
         ...innerTableData.slice(0, index),
         obj,
         ...innerTableData.slice(index + 1),
      ]);
   };

   const onCancel = () => {
      props.refreshData();
   };

   const onSubmit = () => {
      setIsLoading(true);
      let payload = {
         employees: innerTableData.map((el) => {
            return {
               orgEmployeeId: el.orgEmployeeId,
               isEnable: el.isActive,
            };
         }),
      };
      Axios.post('/GSB/dashboard/permission/AdjustSpecialist', payload)
         .then(() => {
            enqueueSnackbar('แก้ไข Spaciallist สำเร็จ', {
               variant: 'success',
            });
            props.refreshData();
         })
         .catch((e) => {
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoading(false);
         });
   };

   const checkboxChangeCallback = (v) => {
      let payload = { isEnable: v };
      setSelectShowDashboard(v);
      Axios.post(
         '/GSB/dashboard/permission/EnableSpecialistDisplayable',
         payload,
      )
         .then(() => {
            enqueueSnackbar('อัพเดท status สำเร็จ', { variant: 'success' });
         })
         .catch((e) => {
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         });
   };

   useEffect(() => {
      setSelectShowDashboard(props.permission.isEnable);
   }, []);

   return (
      <form onSubmit={handleSubmit(onSubmit)}>
         <Box display={'flex'} flexDirection='column' width={1}>
            <Box width={1}>
               <Box width={1}>
                  <Typography>จัดการกลุ่ม Specialist</Typography>
               </Box>
               <Divider />
               <Box>
                  {props.permission && props.permission.isCheckEnable && (
                     <CheckBoxSelect
                        disabled={isLoadingDashboardCheckboxStatus}
                        checkboxLabel={'แสดงเมนู Dashboard'}
                        checkboxValue='allBO'
                        checked={selectShowDashboard}
                        checkboxChangeCallback={checkboxChangeCallback}
                     />
                  )}
               </Box>
               <Box>
                  <Typography>ค้นหารายชื่อ</Typography>
                  {/* {dataModel.empName.length !== 0 ? (
              dataModel.empName.map(({ label, value }) => (
                <div style={{ padding: '0.25rem' }}>
                  <Chip
                    label={label}
                    key={value}
                    onDelete={handleDelete}
                  />
                </div>
              ))
            ) : ( */}
                  <SearchEmployee
                     value={selected}
                     onChange={handleSelect}
                     menuPortalTarget={document.querySelector('body')}
                  />
                  {/* )} */}
               </Box>
               <Box>
                  <Typography>สังกัด</Typography>
                  <Box>
                     <Input
                        name={'division'}
                        placeholder={'สังกัด'}
                        disabled
                        value={selected ? selected.data.department : ''}
                     />
                  </Box>
               </Box>
               <Box mt={3}>
                  <Box>
                     <Button
                        variant={'contained'}
                        color={'primary'}
                        onClick={onAddEmployee}
                     >
                        เพิ่มรายชื่อลงในตาราง
                     </Button>
                  </Box>
               </Box>
            </Box>
            <Box width={1} mt={3}>
               <Box>
                  <MaterialTable
                     // isLoading={isLoading}
                     columns={columnsA}
                     data={innerTableData}
                     options={{
                        // selection: true,
                        showTitle: false,
                        headerStyle: headerStyle,
                        actionsColumnIndex: -1,
                        addRowPosition: 'first',
                        actionsCellStyle: {
                           color: '#ccc',
                        },
                        padding: 'dense',
                        search: false,
                        toolbar: false,
                     }}
                     localization={{
                        body: {
                           editRow: {
                              deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?',
                           },
                        },
                        header: { actions: 'ตัวจัดการ' },
                     }}
                     style={tableStyle}
                     icons={tableIcons}
                     actions={[
                        (rowData) => ({
                           icon: React.forwardRef((props, ref) => (
                              <Switch
                                 onChange={onToggleActive(rowData)}
                                 ref={ref}
                                 {...props}
                                 checked={rowData.isActive}
                                 inputProps={{
                                    'aria-label': 'secondary checkbox',
                                 }}
                              />
                           )),
                           tooltip: rowData.isActive
                              ? 'Is Active'
                              : 'No Active',
                           // onClick: (event, rowData) => UpdateItemCategory(rowData),
                        }),
                     ]}
                  />
                  <Box mt={3}>
                     <Box>
                        <Button
                           variant={'contained'}
                           color={'primary'}
                           type={'submit'}
                        >
                           บันทึก
                        </Button>
                        <Button variant={'contained'} onClick={onCancel}>
                           ยกเลิก
                        </Button>
                     </Box>
                  </Box>
               </Box>
            </Box>
         </Box>
      </form>
   );
}

export default PermissionBoxConfig;
